<template>
  <div class="dppl-accordion-panels bg-bgDefault w-100">
    <DpplAccordionPanel
      v-for="item in items"
      :key="item[keyForId]"
      v-model="currentOpenPanel"
      :item-id="item[keyForId]"
    >
      <template #panel-header>
        <slot name="header" :item="item" />
      </template>
      <template #panel-content>
        <slot name="content" :item="item" />
      </template>
    </DpplAccordionPanel>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import DpplAccordionPanel from '@/components/datapeople/DpplAccordionPanels/DpplAccordionPanel.vue';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  keyForId: {
    type: String,
    default: 'id',
  },
  modelValue: {
    type: [Number, String],
    default: 0,
  },
});

const emit = defineEmits(['update:model-value']);

const currentOpenPanel = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:model-value', value),
});
</script>

<style lang="less" scoped>
:deep(label) {
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
}
</style>
